import { Grid } from '@mui/material';
import { useState } from 'react';
import Tabs, { TabContent, TabItem, TabPanel } from 'components/Input/Tab';
import RequestPlanPreviewTap2 from './RequestPlanPreviewTap2';
import RequestPlanPreviewTap1 from './RequestPlanPreviewTap1';

const RequestPlanPreview = () => {
    const sBackgroundTab = "rgb(31 101 153)";
    const sBackgroundTabActive = "linear-gradient(rgb(15 188 213) 33%, rgb(75 196 235 / 57%) 71%, rgb(165 246 255 / 68%) 87%, rgb(255, 255, 255) 100%)";
    const [sTabID, setsTabID] = useState("Preview_Tab1");

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%' }}>
            <Tabs id={"Preview"} defaultTab={sTabID} onTabChange={(e) => { setsTabID(e); }}>
                <TabItem id="Preview_Tab1" isSub={true} sBackgroundTab={sBackgroundTab} sBackgroundTabActive={sBackgroundTabActive} >กท. 2/1</TabItem>
                <TabItem id="Preview_Tab2" isSub={true} sBackgroundTab={sBackgroundTab} sBackgroundTabActive={sBackgroundTabActive} >กท. 2/2</TabItem>
                <TabContent id={"Preview1"}>
                    <TabPanel isSub={true} id="Preview_Tab1">
                        {/* แผนปฎิบัติงาน 2/1 */}
                        <RequestPlanPreviewTap1 />
                    </TabPanel>
                    <TabPanel isSub={true} id="Preview_Tab2">
                        {/* แผนการใช้จ่ายเงิน 2/2 */}
                        <RequestPlanPreviewTap2  />
                    </TabPanel>
                </TabContent>
            </Tabs>
        </Grid>
    )
}
export default RequestPlanPreview;